import { withInstall } from '@vuesax-plus/utils'

import Star from './src/star.vue'

export const IconStar = withInstall(Star)

export default IconStar
